// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"561a6072","83":"79ba2145","93":"c9f40574","199":"f2be423a","229":"f9df85c9","288":"be497afa","565":"4d0d7f31","651":"6c2ff4fe","743":"3cdb37a8","835":"f728dc50","892":"d252bb69","950":"94af2dc1"}[chunkId] + ".chunk.js";
};